
import { computed, defineComponent, PropType, reactive, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { ReceiverT } from '@/core/types/receivers.types'

// realisations
import { receivers } from '@/core/realisations/receivers.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<ReceiverT>,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'update', 'deleted'],
    setup(props, { emit }) {
        const state = reactive({
            is_deleting: false,
        })

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const notifications = useNotifications()

        const emitDelete = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить получателя ${props.item.title}?`
            )

            if (!answer) return

            try {
                state.is_deleting = true

                await receivers.deleteReceiver(props.item.id)
                notifications.notify({
                    title: `Получатель ${props.item.title} удалён`,
                    type: 'success',
                })

                emit('deleted')
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `Ошибка при удалении получателя ${props.item.title}`,
                })
            } finally {
                state.is_deleting = false
            }
        }

        const isReceiverHaveCoordinates = computed(() => {
            if (Boolean(props.item.latitude) && Boolean(props.item.longitude)) {
                return true
            }

            return false
        })

        const emitSubmit = () => {
            if (!isReceiverHaveCoordinates.value) {
                notifications.notify({
                    title: 'Не указан адрес',
                    description: 'Пожалуйста, укажите адрес на карте',
                    type: 'danger',
                })

                emit('update', toRaw(props.item))
                return
            }

            emit('submit', toRaw(props.item))
        }

        return { state, emitSubmit, emitUpdate, emitDelete, isReceiverHaveCoordinates }
    },
})
